import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const L2Dashboard = lazy(() => import('./pages/L2Dashboard'));
const L3Layout = lazy(() => import('./pages/L3Layout'));
const L3Dashboard = lazy(() => import('./pages/L3Dashboard'));
const L3List = lazy(() => import('./pages/L3List'));
const L3ReviewLog = lazy(() => import('./pages/L3ReviewLog'));
const L3ReviewTags = lazy(() => import('./pages/L3ReviewTags'));
const L3Prompt = lazy(() => import('./pages/L3Prompt'));
const L3Refresh = lazy(() => import('./pages/L3Refresh'));
const L3Setup = lazy(() => import('./pages/L3Setup'));

export const supportRoutes: RouteObject = {
  path: 'support',
  handle: { breadcrumb: 'Support' },
  children: [
    {
      path: 'l2',
      element: <L2Dashboard />,
      handle: { breadcrumb: 'L2 Dashboard' },
    },
    {
      path: 'l3',
      element: <L3Layout />,
      handle: { breadcrumb: 'L3 Dashboard' },
      children: [
        { index: true, element: <L3Dashboard />, handle: { breadcrumb: 'Dashboard' } },
        { path: 'list', element: <L3List />, handle: { breadcrumb: 'List' } },
        { path: 'review-log', element: <L3ReviewLog />, handle: { breadcrumb: 'Review Log' } },
        { path: 'review-tags', element: <L3ReviewTags />, handle: { breadcrumb: 'Review Tags' } },
        { path: 'prompt', element: <L3Prompt />, handle: { breadcrumb: 'Prompt' } },
        { path: 'refresh', element: <L3Refresh />, handle: { breadcrumb: 'Refresh' } },
        { path: 'setup', element: <L3Setup />, handle: { breadcrumb: 'Setup' } },
      ],
    },
  ],
};
